module.exports = __webpack_public_path__ + "img/Head lamp.30007cf0.jpg";